import {Injectable, NgZone} from '@angular/core';
import {AngularFireFunctions} from "@angular/fire/compat/functions";
import {AngularFireAuth} from "@angular/fire/compat/auth";
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {Router} from "@angular/router";
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {WindowService} from './window.service';
import {User} from 'firebase/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public accountData: User | null;
  public isAdmin: boolean = false;
  public isOperator: boolean = false;
  public isUser: boolean = false;
  public firestore_id: any = null;

  constructor (
    public win: WindowService,
    public afs: AngularFirestore,
    public afAuth: AngularFireAuth,
    public aff: AngularFireFunctions,
    public router: Router,
    public ngZone: NgZone,
    private snackBar: SnackBarIconService
  ) {
    this.afAuth.authState.subscribe(async (account) => {
      this.accountData = account;
      if (account) {
        sessionStorage.setItem('account', JSON.stringify(this.accountData));
        await this.getClaims();
      } else {
        sessionStorage.setItem('account', null);
        //this.router.navigate([ 'sign-in' ]);
        this.isAdmin = this.isOperator = this.isUser = false;
      }
    });
  }

  async getClaims () {
    try {
      const user = await this.afAuth.currentUser;
      if (user) {
        const idTokenResult = await user.getIdTokenResult();
        this.isAdmin = !!idTokenResult.claims.admin;
        this.isOperator = !!idTokenResult.claims.operator;
        this.isUser = !!idTokenResult.claims.user;
      }
    } catch (error) {
      console.error("Erro ao obter claims:", error);
      this.isAdmin = this.isOperator = this.isUser = false;
    }
  }

  /**
   * Realiza o login com e-mail e senha e navega para '/wellcome' em caso de sucesso.
   */
  async SignIn (email: string, password: string): Promise<void> {
    try {
      // 1. Aguarda a conclusão bem-sucedida do login do Firebase
      await this.afAuth.signInWithEmailAndPassword(email, password);

      // Garante que as claims e o estado interno do serviço estejam atualizados
      // antes de qualquer tentativa de navegação que possa depender deles.
      await this.getClaims();

      // 2. Se o login for bem-sucedido, executa a navegação DENTRO da Zone.
      this.ngZone.run(() => {
        console.log("logged ------------------------");

        // CORREÇÃO DE SINCRONIZAÇÃO: Usamos setTimeout(0) para garantir que
        // a atualização do estado do serviço seja processada antes do roteamento.
        setTimeout(() => {
          this.router.navigate([ '/wellcome' ]);
          console.log("Tentativa de navegação para /wellcome realizada.");
        }, 0);
      });

    } catch (error) {
      // 3. Em caso de erro, exibe o SnackBar
      this.snackBar.openSnackBar("Email ou senha inválidos", '', 'error');
      console.error(error);
    }
  }



  async SendVerificationMail () {
    const user = await this.afAuth.currentUser;
    if (user) {
      return user.sendEmailVerification()
        .then(() => {
          this.router.navigate([ 'verify-email' ]);
        });
    }
  }

  async ForgotPassword (passwordResetEmail) {
    return this.afAuth.sendPasswordResetEmail(passwordResetEmail)
      .then(() => {
        this.snackBar.openSnackBar("Email enviado. Verifique sua caixa de correio.", '', 'info');
      }).catch(() => {
        this.snackBar.openSnackBar("Não temos este e-mail cadastrado. Verifique a digitação.", '', 'warn');
      });
  }

  SignOut () {
    return this.afAuth.signOut().then(() => {
      sessionStorage.removeItem('account');
      sessionStorage.removeItem('data-member'); // login by cellPhone
      this.router.navigate([ 'home' ]);
    });
  }

  async PhoneSignIn (phoneNumber: string, recaptchaVerifier: any) {
    return this.afAuth.signInWithPhoneNumber(phoneNumber, recaptchaVerifier);
  }

  async VerifyOTP (confirmationResult: any, verificationCode: string) {
    return confirmationResult.confirm(verificationCode);
  }

  async currentClaims () {
    const user = await this.afAuth.currentUser;
    if (user) {
      return user.getIdTokenResult();
    }
    return null;
  }
  // Retorna o usuário logado
  async getCurrentUser () {
    return await this.afAuth.currentUser;
  }

  // ----------------------------------------------------------------------
  // Métodos restaurados com a nova sintaxe
  // ----------------------------------------------------------------------

  /**
   * Getter para verificar se o usuário está logado.
   * Utiliza o `sessionStorage` para verificar rapidamente o status de autenticação.
   */
  get isLoggedIn (): boolean {
    const account = sessionStorage.getItem('account');
    return account !== null && account !== 'null';
  }

  /**
   * Retorna os dados do usuário logado do `sessionStorage`.
   * @returns Os dados do usuário ou `null`.
   */
  getLogged (): User | null {
    const account = sessionStorage.getItem('account');
    if (account && account !== 'null') {
      return JSON.parse(account);
    }
    return null;
  }

  /**
   * Retorna o ID do usuário logado.
   * @returns O ID do usuário (UID) ou `null`.
   */
  getIdLogged (): string | null {
    const account = this.getLogged();
    return account ? account.uid : null;
  }
}